var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-col',{staticClass:"mb-5 pb-5"},[_c('v-row',[_c('v-col',{attrs:{"cols":"12"}},[_c('iframe',{attrs:{"width":"100%","height":"700","src":"https://lamonnaiepirate.net"}}),_vm._v("> ")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }